/*
 * timetracking.js
 *
 * Time tracking related helper functions
 */

import moment from "moment";
import Flagship from "../core/flagship";

export function addTimerEventListeners(data, dispatch, message, forceVisible) {
  refreshTimer(data, dispatch, message, forceVisible);

  window.addEventListener("focus", () => {
    dispatch({
      type: "WINDOW_BLUR",
      blurred: false
    });
    getRefreshedTimer(data.userId, data, dispatch);
  });

  window.addEventListener("blur", () => {
    dispatch({
      type: "WINDOW_BLUR",
      blurred: true
    });
  });
}

function refreshTimer(
  data,
  dispatch,
  message = "You still have a timer running.",
  forceVisible = false
) {
  if (data !== null) {
    let banked = data.timer_banked;

    let time = parseInt(banked);
    let running = false;

    if (Number.isNaN(time)) {
      time = 0;
    }
    if (time < 0) {
      time = 0;
    }

    if (data.timer_client !== "") {
      data.timer_client = JSON.parse(data.timer_client);
    }

    if (data.timer_start !== null) {
      running = true;
      time += Math.round(
        moment.duration(moment().diff(data.timer_start)).asSeconds()
      );
      clearInterval(window.timer);

      if (message !== false) {
        Flagship.notify(message, "info");
      }

      window.timer = setInterval(function() {
        dispatch({
          type: "INCREMENT_TIMER"
        });
      }, 1000);
    } else {
      clearInterval(window.timer);
    }

    dispatch({
      type: "SET_TIMER",
      client: data.timer_client,
      task: data.timer_task,
      running,
      time,
      forceVisible
    });
  }
}

function getRefreshedTimer(userId, data, dispatch) {
  Flagship.post("/timesheets/timer/refresh", { userId }, function(response) {
    refreshTimer(
      response.data.length ? response.data[0] : null,
      dispatch,
      null
    );
  });
}



// WEBPACK FOOTER //
// ./src/utils/timetracking.js